module.exports = __webpack_public_path__ + "img/icon-comment.png";